module.exports = __webpack_public_path__ + "img/CV.0f0d939f.png";